import * as appsettings from "../appsettings";
import * as navigation  from "../navigation";

export function initialize(): void { }

export function initialize_EditInfo(): void { }

export function TAB_ExtraInfo_editButtonClicked(nodeId: number): void {
    // load edit view
    navigation.navigateToSpecificUrl("Information/Edit?nodeId=" + nodeId);
}

export function onImageChanged(e: kendo.ui.DropDownListChangeEvent): void {

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Information/GetImage"),
        data: { figureId: e.sender.value() },
        success: function (responseData) {

            const btn = $("#deleteButton");
            const image = $("#figureImage");
            if (image != null && image != undefined && responseData != null && responseData != "") {
                image.attr("src", responseData);
                image.removeAttr("hidden");
                btn.removeAttr("disabled");
            } else {
                image.attr("hidden", "hidden");
                btn.attr("disabled", "disabled");
            }

        }
    });
}


export function onDeleteButtonClicked(e: HTMLInputElement): void {

    const cbb = $("#ImgID").data("kendoDropDownList");
    cbb.value(null);
    cbb.trigger("change");
}
